<template lang="pug">
bottom-modal(id="setValuesForm", ref="modal", :loading="onLoading('save-set')")
    template(slot="header-text")
        | Update Settings Set
    template(slot="body")
        .container
            .padding
                form
                    fieldset(:disabled="onLoading('save-set')")
                        .row
                            .col-md-4
                                .box
                                    .box-header.b-b
                                        h3 General

                                    .box-body
                                        .form-group
                                            label Name
                                            input.form-control(
                                                type="text",
                                                name="name",
                                                :disabled="isDefault",
                                                :value="settingSet.name",
                                                @input="setSettingSetAttibute({ value: $event.target.value, attr: 'name' })"
                                            )

                                        .form-group
                                            label Description
                                            textarea.form-control(
                                                rows="4",
                                                :disabled="isDefault",
                                                :value="settingSet.description",
                                                @input="setSettingSetAttibute({ value: $event.target.value, attr: 'description' })"
                                            )

                                        p(v-show="!isDefault") Assigned Outlets
                                        multiselect(
                                            v-show="!isDefault",
                                            v-model="outlets",
                                            :options="outletOptions",
                                            :searchable="false",
                                            :close-on-select="false",
                                            :hide-selected="true",
                                            track-by="id",
                                            :multiple="true",
                                            label="name",
                                            placeholder="Select Outlet"
                                        )
                            .col-md-8
                                form-container(:validator="$validator")

    template(slot="footer")
        button.btn.btn-fw.primary(:disabled="!canManageSettings" @click="submit")
            v-loading(loader="save-set") Save
</template>

<script>
import formContainer from './central-setting-form-container.vue';
import { mapActions, mapGetters } from 'vuex';
import event from './central-setting-event';
import PermissionMixin from '../settings-permission';

export default {
    components: { formContainer },

    mixins: [PermissionMixin],

    computed: {
        ...mapGetters('outlet', ['outletList']),
        ...mapGetters('centralSettings', ['settingSet', 'outletTaken']),

        outlets: {
            get() {
                return this.settingSet.outlets;
            },
            set(outlets) {
                this.setOutlets(outlets);
            },
        },

        outletOptions() {
            const outletTaken = this.outletTaken(this.settingSet.id);
            return this.outletList.filter(
                o => !outletTaken.find(ot => o.id == ot),
            );
        },

        isDefault() {
            return this.settingSet.default;
        },
    },

    mounted() {
        this.$on('show', id => {
            this.getSet(id);
        });

        event.$on('show-update-form', settingSet => {
            this.$validator.errors.clear();
            this.setSettingSet(settingSet);
            this.$refs.modal.$emit('show');
        });
    },

    methods: {
        ...mapActions('centralSettings', [
            'getSettingSet',
            'setSettingSet',
            'updateSettingSet',
            'setSettingSetAttibute',
            'setOutlets',
        ]),

        async getSet(id) {
            if (this.onLoading('fetch-set')) return;

            this.startLoading('fetch-set');

            let { data } = await this.getSettingSet(id);
            event.$emit('show-update-form', data);
            this.endLoading('fetch-set');

            return data;
        },

        async submit() {
            if (this.$isLoading('save-set')) return;

            this.$startLoading('save-set');

            try {
                const { data } = await this.updateSettingSet(this.settingSet);

                this.setSettingSet(data);
                this.showToastrSuccess();
                this.$refs.modal.$emit('hide');
                event.$emit('set-updated');
            } catch (err_response) {
                this.processLaravelErrors(
                    this.$validator,
                    err_response.response,
                );

                if (this.$validator.errors.items.length) {
                    const errors = this.$validator.errors.items.map(i => i.msg);

                    swal({
                        title: 'Error',
                        type: 'error',
                        text: errors.toString(),
                        showCloseButton: true,
                    });
                }
            }

            this.$endLoading('save-set');
        },
    },
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/franchise_component/setting/central-settings/central-setting-set-update.vue